import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Menu from '../../components/layout/Drawer';
import Main from '../../components/layout/Main';
import { useMediaQuery } from '@material-ui/core';
import stylesGenerator from './styles';
import { Routes, routesArray } from './routes';

const drawerWidth = 240;

const useStyles = stylesGenerator({});

function App(props: any): React.ReactElement {
  const classes = useStyles();
  const [drawerOpen, setDrawerState] = React.useState(false);
  const [ filterYear, setFilterYear ] = React.useState<any>(new Date().getFullYear());

  const handleFilterYearChange = (e: any) => {
    setFilterYear(e.target.value);
  }
  const openDrawer = () => {
    setDrawerState(true);
  }

  const closeDrawer = () => {
    setDrawerState(false);
  }

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  const menuItemClicked = () => {
    setDrawerState(!isSmallScreen)
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      {/* <NavBar openHandler={openDrawer}/> */}
      <Menu  filterYear={filterYear} handleFilterYearChange={handleFilterYearChange} drawerWidth={drawerWidth} drawerOpen={drawerOpen} openHandler={openDrawer} closeHandler={closeDrawer} menuItems={routesArray} menuItemClickHandler={menuItemClicked}/>
      <Main>
        <Routes {...props} filterYear={filterYear} handleFilterYearChange={handleFilterYearChange}/>
      </Main>
    </div>
  );
}

export default App;
